<template>
    <div style="width:85%;margin:auto;padding-top:10px;color:#7b7c87">
        
        <v-layout row wrap>
            <v-flex xs12 md12 lg12 xl12 style="padding:15px;padding-bottom:2px !important"><!--Row #1-->
                <v-layout row wrap>
                    <v-flex xs12 sm12 md10 lg10 xl10 style="padding:15px;padding-bottom:0px;">
                    <div style="padding-top:23px;font-weight:bolder;font-size:20px">تنظیمات سایت</div>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 md12 lg12 xl12 style="padding:15px;"><!--Row #2-->
                  <v-card>
                    <v-card-text>
                      <v-layout row wrap>
                          <v-flex xs12 sm12 md6 lg6 xl6 style="padding:20px">
                              <div class="flex-boxs">
                                  <v-row>
                                      <v-col cols="12">
                                          <b>وضعیت فروشگاه</b>
                                      </v-col>
                                      <v-col cols="10">
                                          <v-row>
                                            <v-col cols="8">{{ShopState ? "فعال":"غیر فعال"}} :</v-col>
                                            <v-col cols="4" style="display: flex;justify-content: flex-end;">
                                                <v-switch v-model="ShopState" style="padding-top:0px !important;margin-top:0px !important" color="#2a2d45"></v-switch>
                                            </v-col>
                                        </v-row>
                                      </v-col>
                                      <v-col cols="2">
                                          <v-btn outlined @click="AddOption('SHOPSTATE',ShopState)"  color="#262d47"><v-icon small style="padding-left:0px" color="#262d47">fa fa-check</v-icon></v-btn>
                                      </v-col>
                                  </v-row>
                              </div>
                          </v-flex>
                          <v-flex xs12 sm12 md6 lg6 xl6 style="padding:20px">
                              <div class="flex-boxs">
                                  <v-row>
                                      <v-col cols="12">
                                          <b>وضعیت ورود کاربران</b>
                                      </v-col>
                                      <v-col cols="10">
                                          <v-row>
                                            <v-col cols="8">{{LoginState ? "فعال":"غیر فعال"}} :</v-col>
                                            <v-col cols="4" style="display: flex;justify-content: flex-end;">
                                                <v-switch v-model="LoginState" style="padding-top:0px !important;margin-top:0px !important" color="#2a2d45"></v-switch>
                                            </v-col>
                                        </v-row>
                                      </v-col>
                                      <v-col cols="2">
                                          <v-btn outlined @click="AddOption('LOGINSTATE',LoginState)"  color="#262d47"><v-icon small style="padding-left:0px" color="#262d47">fa fa-check</v-icon></v-btn>
                                      </v-col>
                                  </v-row>
                              </div>
                          </v-flex>
                          <v-flex xs12 sm12 md6 lg6 xl6 style="padding:20px">
                              <div class="flex-boxs">
                                  <v-row>
                                      <v-col cols="12">
                                          <b>وضعیت ثبت نام کاربران</b>
                                      </v-col>
                                      <v-col cols="10">
                                          <v-row>
                                            <v-col cols="8">{{RegisterState ? "فعال":"غیر فعال"}} :</v-col>
                                            <v-col cols="4" style="display: flex;justify-content: flex-end;">
                                                <v-switch v-model="RegisterState" style="padding-top:0px !important;margin-top:0px !important" color="#2a2d45"></v-switch>
                                            </v-col>
                                        </v-row>
                                      </v-col>
                                      <v-col cols="2">
                                          <v-btn outlined @click="AddOption('REGISTERSTATE',RegisterState)"  color="#262d47"><v-icon small style="padding-left:0px" color="#262d47">fa fa-check</v-icon></v-btn>
                                      </v-col>
                                  </v-row>
                              </div>
                          </v-flex>
                          <v-flex xs12 sm12 md6 lg6 xl6 style="padding:20px">
                              <div class="flex-boxs">
                                  <v-row>
                                      <v-col cols="12">
                                          <b>وضعیت سیستم فروش </b>
                                      </v-col>
                                      <v-col cols="10">
                                          <v-row>
                                            <v-col cols="8">{{HideProductPrice ? "فعال":"غیر فعال"}} :</v-col>
                                            <v-col cols="4" style="display: flex;justify-content: flex-end;">
                                                <v-switch v-model="HideProductPrice" style="padding-top:0px !important;margin-top:0px !important" color="#2a2d45"></v-switch>
                                            </v-col>
                                        </v-row>
                                      </v-col>
                                      <v-col cols="2">
                                          <v-btn outlined @click="AddOption('HIDEPRODUCTPRICE',HideProductPrice)"  color="#262d47"><v-icon small style="padding-left:0px" color="#262d47">fa fa-check</v-icon></v-btn>
                                      </v-col>
                                  </v-row>
                              </div>
                          </v-flex>
                          <v-flex xs12 sm12 md6 lg6 xl6 style="padding:20px">
                              <div class="flex-boxs">
                                  <v-row>
                                      <v-col cols="12">
                                          <b>حذف تمامی تخفیفات</b>
                                      </v-col>
                                      <v-col cols="10">
                                          <v-row>
                                            <v-col cols="8">{{DeleteDiscounts ? "فعال":"غیر فعال"}} :</v-col>
                                            <v-col cols="4" style="display: flex;justify-content: flex-end;">
                                                <v-switch v-model="DeleteDiscounts" style="padding-top:0px !important;margin-top:0px !important" color="#2a2d45"></v-switch>
                                            </v-col>
                                        </v-row>
                                      </v-col>
                                      <v-col cols="2">
                                          <v-btn outlined @click="AddOption('DELETEDISCOUNTS',DeleteDiscounts)"  color="#262d47"><v-icon small style="padding-left:0px" color="#262d47">fa fa-check</v-icon></v-btn>
                                      </v-col>
                                  </v-row>
                              </div>
                          </v-flex>
                          <v-flex xs12 sm12 md6 lg6 xl6 style="padding:20px">
                              <div class="flex-boxs">
                                  <v-row>
                                      <v-col cols="12">
                                          <b>وضعیت  فروش ویژه</b>
                                      </v-col>
                                      <v-col cols="10">
                                          <v-row>
                                            <v-col cols="8">{{SpecialSaleState ? "فعال":"غیر فعال"}} :</v-col>
                                            <v-col cols="4" style="display: flex;justify-content: flex-end;">
                                                <v-switch v-model="SpecialSaleState" style="padding-top:0px !important;margin-top:0px !important" color="#2a2d45"></v-switch>
                                            </v-col>
                                        </v-row>
                                      </v-col>
                                      <v-col cols="2">
                                          <v-btn outlined @click="AddOption('SPECIALSALESTATE',SpecialSaleState)"  color="#262d47"><v-icon small style="padding-left:0px" color="#262d47">fa fa-check</v-icon></v-btn>
                                      </v-col>
                                  </v-row>
                              </div>
                          </v-flex>
                          <v-flex xs12 sm12 md6 lg6 xl6 style="padding:20px">
                              <div class="flex-boxs">
                                  <v-row>
                                      <v-col cols="12">
                                          <b>ارزش افزوده</b>
                                      </v-col>
                                      <v-col cols="10">
                                          <v-row>
                                            <v-col cols="4">مبلغ :</v-col>
                                            <v-col cols="8" style="display: flex;justify-content: flex-end;">
                                                <v-text-field style="padding-top:0px !important;margin-top:0px !important" outlined dense persistent-hint hint="این عدد درصدی محاسبه میگردد.مثلا 5 به معنای 5 درصد سبد خرید است" v-model.number="Tax"></v-text-field>
                                            </v-col>
                                        </v-row>
                                      </v-col>
                                      <v-col cols="2">
                                          <v-btn outlined @click="AddOption('TAX',Tax)"  color="#262d47"><v-icon small style="padding-left:0px" color="#262d47">fa fa-check</v-icon></v-btn>
                                      </v-col>
                                  </v-row>
                              </div>
                          </v-flex>
                          <v-flex xs12 sm12 md6 lg6 xl6 style="padding:20px">
                              <div class="flex-boxs">
                                  <v-row>
                                      <v-col cols="12">
                                          <b>هزینه ارسال کالا</b>
                                      </v-col>
                                      <v-col cols="12">
                                          <v-row>
                                            <v-col cols="3" class="d-flex align-center">مبلغ سبد خرید از </v-col>
                                            <v-col cols="2" class="d-flex align-center"><v-text-field dense outlined type="number" step="10000" v-model.number="ShippingMethod.BF0"></v-text-field> </v-col>
                                            <v-col cols="1" class="d-flex align-center">تا </v-col>
                                            <v-col cols="2" class="d-flex align-center"><v-text-field dense outlined type="number" step="10000" v-model.number="ShippingMethod.BT0"></v-text-field> </v-col>
                                            <v-col cols="1" class="d-flex align-center" style="font-size:22px"> = </v-col>
                                            <v-col cols="3" class="d-flex align-center"><v-text-field dense outlined type="number" step="10000" v-model.number="ShippingMethod.SC0"></v-text-field> </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="3" class="d-flex align-center">مبلغ سبد خرید از </v-col>
                                            <v-col cols="2" class="d-flex align-center"><v-text-field dense outlined type="number" step="10000" v-model.number="ShippingMethod.BF1"></v-text-field> </v-col>
                                            <v-col cols="1" class="d-flex align-center">تا </v-col>
                                            <v-col cols="2" class="d-flex align-center"><v-text-field dense outlined type="number" step="10000" v-model.number="ShippingMethod.BT1"></v-text-field> </v-col>
                                            <v-col cols="1" class="d-flex align-center" style="font-size:22px"> = </v-col>
                                            <v-col cols="3" class="d-flex align-center"><v-text-field dense outlined type="number" step="10000" v-model.number="ShippingMethod.SC1"></v-text-field> </v-col>
                                        </v-row>
                                      </v-col>
                                      <v-col cols="12">
                                          <v-btn block outlined @click="AddOption('SHIPPINGMETHOD',JSON.stringify(ShippingMethod))"  color="#262d47"><v-icon small style="padding-left:0px" color="#262d47">fa fa-check</v-icon></v-btn>
                                      </v-col>
                                  </v-row>
                              </div>
                          </v-flex>
                          <v-flex xs12 sm12 md6 lg6 xl6 style="padding:20px">
                              <div class="flex-boxs">
                                  <v-row>
                                      <v-col cols="12">
                                          <b>وضعیت   باکس های صفحه اول</b>
                                      </v-col>
                                      <v-col cols="10">
                                          <v-row>
                                            <v-col cols="8">{{IndexBoxState ? "فعال":"غیر فعال"}} :</v-col>
                                            <v-col cols="4" style="display: flex;justify-content: flex-end;">
                                                <v-switch v-model="IndexBoxState" style="padding-top:0px !important;margin-top:0px !important" color="#2a2d45"></v-switch>
                                            </v-col>
                                        </v-row>
                                      </v-col>
                                      <v-col cols="2">
                                          <v-btn outlined @click="AddOption('INDEXBOXSTATE',IndexBoxState)"  color="#262d47"><v-icon small style="padding-left:0px" color="#262d47">fa fa-check</v-icon></v-btn>
                                      </v-col>
                                  </v-row>
                              </div>
                          </v-flex>
                      </v-layout>
                  </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
       
        <template><!--Loading Dialog-->
            <div class="vld-parent">
                <loading color="#f75314" :width="parseInt(45)" :height="parseInt(45)" background-color="#fff" :active.sync="isLoading" 
                :is-full-page="true"></loading>
                
               
            </div>
        </template>
    </div>
</template>

<style scoped>
.flex-boxs
{
    width: 100%;
    min-height: 50px;
    border:1px solid rgb(177, 177, 177);
    border-radius: 2px;
    padding: 10px;
    max-height: auto;
    height: auto;
}
.overFlowHidden .v-dialog:not(.v-dialog--fullscreen)
{
    overflow: hidden !important;
}
.overFlowHidden 
{
    max-width: 400px;
    max-height: 400px;
    overflow: hidden !important;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
}
</style>
<script>
const axios = require("axios");
const ApiUrl = require('../../constant/apiurl');
const MSGHNDL = require('../../constant/MessageHandler');
const FTYPES = require('../../constant/setting/Default/AllowedFileTypes');
const FSIZE = require('../../constant/setting/Default/AllowedFileSize');
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { VueEditor } from "vue2-editor";
export default {
    name:"setting",
   components: {
            Loading,
            VueEditor
        },
    data:()=> ({
        ShippingMethod:{BF0:0,BT0:0,SC0:0 ,BF1:0,BT1:0,SC1:0},
        ConvertBase:1,
        BonPercentage:0,
        ShippingPrice:0,
        isLoading:false,
        ShopState:true,
        LoginState:true,
        RegisterState:true,
        HideProductPrice:false,
        DeleteDiscounts:false,
        SpecialSaleState:true,
        IndexBoxState:true,
        Tax:0
    }),
    async created()
    {
        let vm = this;
       axios.interceptors.request.use((config) => {
            vm.isLoading = true;
            return config;
        }, (error) => {
            vm.isLoading = false;
            return Promise.reject(error);
        });

        axios.interceptors.response.use((response) => {
            vm.isLoading = false;
            return response;
        }, (error) => {
            vm.isLoading = false;
            return Promise.reject(error);
        });
       await this.loadCategories();
       this.ALLOEWDIMGSIZE = FSIZE.PRDCATIMGSIZE;
    },
    computed:{
        LANG(){
        return this.$store.getters.GetLang;
        }
    },
    watch:{
        LANG(nL,oL){
        this.loadCategories();
        }
    },
    methods:{
        async AddOption(key,val)
        {
            var vm = this;
            var Model = {};
           
            Model.O_Key = key;
            Model.O_Value = val;
            await axios.post(ApiUrl.AddOption,Model)
            .then(async (res)=>{
                var data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    await vm.loadCategories();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((error)=>{
                console.error(error);
                MSGHNDL.ERR(error);
            });
        },
        async loadCategories()
        {
            let vm = this;
            vm.isLoading  = true;
            await axios.post(ApiUrl.LoadOptions,{}).then(async (res)=>{
                let data = res.data;
                console.warn(data);
                if(data.status)
                {
                    if(data.data.length > 0)
                    {
                        data.data.forEach(item => {
                            if(item.o_Key == "SHOPSTATE")
                            {
                                vm.ShopState = item.o_Value == "true" ? true:false;
                            }
                            if(item.o_Key == "LOGINSTATE")
                            {
                                vm.LoginState = item.o_Value == "true" ? true:false;
                            }
                            if(item.o_Key == "SHIPPINGPRICE")
                            {
                                vm.ShippingPrice = item.o_Value == "true" ? true:false;
                            }
                            if(item.o_Key == "REGISTERSTATE")
                            {
                                vm.RegisterState = item.o_Value == "true" ? true:false;
                            }
                            if(item.o_Key == "HIDEPRODUCTPRICE")
                            {
                                vm.HideProductPrice = item.o_Value == "true" ? true:false;
                            }
                            if(item.o_Key == "DELETEDISCOUNTS")
                            {
                                vm.DeleteDiscounts = item.o_Value == "true" ? true:false;
                            }
                            if(item.o_Key == "SPECIALSALESTATE")
                            {
                                vm.SpecialSaleState = item.o_Value == "true" ? true:false;
                            }
                            if(item.o_Key == "SHIPPINGMETHOD")
                            {
                                vm.ShippingMethod = JSON.parse(item.o_Value);
                            }
                            if(item.o_Key == "TAX")
                            {
                                vm.Tax = item.o_Value;
                            }
                            if(item.o_Key == "INDEXBOXSTATE")
                            {
                                vm.IndexBoxState = item.o_Value == "true" ? true:false;
                            }
                        });
                    }
                }
                vm.isLoading = false
            }).catch((err)=>{
                console.error(err);
            });
        },
    }
}
</script>